import type { TermsDocument } from './types';
import { renderSections } from './renderSections';
import { PageTitle } from 'gossamer-front-end';

type Props = {
  document: TermsDocument;
};

const LegalDocumentPage = ({ document }: Props) => {
  return (
    <div>
      <PageTitle title={document.title} />
      <p className="text-muted">
        Last updated: {document.lastUpdated} | Version {document.version}
      </p>
      {renderSections(document.sections)}
    </div>
  );
};

export default LegalDocumentPage;
